import { useState } from "react";
import { useAuth } from "@/lib/auth";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: "#F9F8F6", fontFamily: "'Satoshi', system-ui, sans-serif" }}>
      <div className="w-full max-w-md bg-white border border-neutral-200 rounded-lg p-8">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-10 h-10 rounded-md flex items-center justify-center" style={{ background: "#D4FF00" }}>
            <Sparkles className="w-6 h-6" color="#1A1A1A" strokeWidth={2} />
          </div>
          <div>
            <div className="font-black text-2xl tracking-tight leading-none" style={{ fontFamily: "'Cabinet Grotesk', system-ui, sans-serif" }}>HOP!</div>
            <div className="text-[10px] uppercase tracking-widest text-neutral-500">Founder Content OS</div>
          </div>
        </div>
        <h1 className="text-3xl font-black tracking-tight mb-1" style={{ fontFamily: "'Cabinet Grotesk', system-ui, sans-serif" }}>Sign in</h1>
        <p className="text-sm text-neutral-600 mb-6">Ship a month of founder content in a day.</p>
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="you@hop.com" className="w-full border border-neutral-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-neutral-900 transition-colors" />
          <input data-testid="password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="Password" className="w-full border border-neutral-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-neutral-900 transition-colors" />
          <button data-testid="login-submit" type="submit" disabled={loading}
            className="w-full py-2.5 rounded-md font-semibold text-sm text-neutral-900 transition-colors disabled:opacity-50"
            style={{ background: "#D4FF00" }}>
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
        <div className="text-sm text-neutral-600 mt-6">
          No account? <Link to="/register" data-testid="go-register" className="font-semibold text-neutral-900 underline">Register</Link>
        </div>
      </div>
    </div>
  );
}
